import { Button, Col, Row } from "react-bootstrap";
import { NoData } from "../common/NoData";
import { updateOquicInsuranceData } from "../../features/product";
import { useDispatch } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import "../customCheckbox.css";
import { useState } from "react";
import { CompanyDetails } from "../CompanyDetails";
import { ReactComponent as OmrSymbol } from "../../assets/SVG/omr_symbol.svg";
// import { OmrSymbol } from "./omr_symbol.svg";


export const OquicCompanyCard = ({ data, buyNowHandler }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [show, setShow] = useState(false);
  const [showAllCovers, setShowAllCovers] = useState(false);
  const handleShow = () => setShow(true);
  const [isCovers, setShowCover] = useState(false);
  const isTravel = data?.product_id === 15 && data?.sub_product_id === 20;

  // Your updated React component
  return (
    <div className="card insurance-card h-100 shadow-sm">
      {/* Header Section */}
      <div className="card-header-custom">
        <a className="details-link" onClick={() => {
          handleShow()
          setShowCover(false)

        }}>
          ⓘ {t("view_details")}
        </a>
        <div className="flex-fill">
          <div className="insurance-row just">
            <div className="insurance-logo mt-6">
              <img
                src={data?.company_image}
                alt={data?.company_name}
              />
            </div>
            <div className="insurance-content mt-2">
              <h4 className="company-title">{t(data.company_name.toLowerCase()
                .trim()
                .replace(/\s+/g, "_")        // replace spaces with _
                .replace(/[^\w_]/g, ""))}</h4>

              <div className="badge-row gap-2">

                <div className="badge-column">
                  <span className="badge-grey">{t('instantInsurance')}</span>
                  <span className="badge-grey">{t('branches')}: 2</span>

                </div>

                <div className="badge-column">
                  <span className="badge-grey">{t('endorsement24to48')}</span>
                  {/* {!isTravel && (
                        <span className="badge-dark-yellow">{t('photosNotRequired')}</span>
                      )}                      */}
                  <span className="badge-dark-yellow">  {t("planName")} - {data?.plan_name.replaceAll('*', '')}</span>

                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Area/Vehicle Value */}
        {/* {data?.product_id === 15 && data?.sub_product_id === 20 ? (
          <div className="badge-light-custom w-100 text-center">
            {t("graphical_area_label")}: {currentLanguage === "ar"
              ? data?.area_of_coverage?.display_value_ar || "NA"
              : data?.area_of_coverage?.display_value_en || "NA"}
          </div>
        ) : (
          <div className="badge-light-custom w-100 text-center">
            {t("vehicle-value")}: {data?.extracted_data?.valuations ||
              data?.extracted_data?.vehicle_valuation ||
              "NA"}
          </div>
        )} */}
      </div>

      <CompanyDetails
        show={show}
        companyData={data}
        isCovers={isCovers}
        handleClose={() => setShow(false)}
      />

      {/* Included Covers Section */}
      <div className="p-3 h-[100px]">
        <h6 className="section-title">{t("includedcovers")}</h6>
        <Row className="g-1">
          {data?.included_covers && data?.included_covers.length ? (
            <>
              {(showAllCovers ? data.included_covers : data.included_covers.slice(0, 4)).map((cover_item, coverIndex) => (
                <Col xs={6} key={`cover_included_${coverIndex}`}>
                  <div className="cover-item">
                    <span className="checkmark-icon">✓</span>
                    <span>
                      {data && data?.product_id !== 15
                        ? currentLanguage === "ar"
                          ? cover_item?.descriptionBl
                          : cover_item?.description
                        : cover_item?.name}
                      {cover_item?.sumInsured && cover_item?.sumInsured !== '0'
                        ? ` - ${cover_item?.sumInsured} ${data?.product_id === 1 &&
                          (data?.sub_product_id === 1 || data?.sub_product_id === 21)
                          ? t('omr')
                          : data.premium_currency
                        }`
                        : ""}
                    </span>
                  </div>
                </Col>
              ))}
              {data.included_covers.length > 4 ? (
                <div className="p-0 m-0">
                  <button
                    className="btn btn-link p-0 m-0 text-decoration-none"
                    style={{ color: '#ff9800', fontSize: '0.9rem' }}
                    // onClick={() => setShowAllCovers(!showAllCovers)}
                    onClick={() => {
                      setShow(true)
                      setShowCover(true)
                    }
                    }
                  >
                    {showAllCovers ? "See less" : t('see_more')}
                  </button>
                </div>
              ) : <div className="">

              </div>}
            </>
          ) : (
            <Col xs={12}>
              <NoData msg={t("noCoverMsg")} />
            </Col>
          )}
        </Row>
      </div>

      {/* Optional Covers Section */}
      <div className="card-body pt-0">
        {data?.optional_covers && data?.optional_covers.length ? (<h6 className="section-title">{t("optionalcovers")}</h6>) : <div></div>}
        {/* <h6 className="section-title">{t("optionalcovers")}</h6> */}
        <Row className="g-2">
          {data?.optional_covers && data?.optional_covers.length ? (
            data.optional_covers.map((cover_item, coverIndex) => (
              <Col xs={6} key={`cover_optional_${coverIndex}`}>
                <div className="optional-item">
                  <input
                    id={`${data?.plan_name
                      ?.toLowerCase()
                      ?.replaceAll(" ", "-")}_cover_cb_${coverIndex}`}
                    type="checkbox"
                    className="checkbox-custom"
                    checked={cover_item?.isSelected}
                    onChange={() =>
                      dispatch(
                        updateOquicInsuranceData({
                          object_id: data?.object_id,
                          value: cover_item?.premium,
                          customAction: cover_item?.isSelected
                            ? "decrement"
                            : "increment",
                          cover_id: cover_item?.code,
                        })
                      )
                    }
                  />
                  <label
                    htmlFor={`${data?.plan_name
                      ?.toLowerCase()
                      ?.replaceAll(" ", "-")}_cover_cb_${coverIndex}`}
                    style={{ cursor: 'pointer', margin: 0 }}
                  >
                    {currentLanguage == 'ar' && cover_item?.name == "Winter Sports Extension" ? "تغطية الرياضات الشتوية" : cover_item?.name}
                  </label>
                </div>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              {/* <NoData msg={t("noCoverMsg")} /> */}
            </Col>
          )}
        </Row>
      </div>

      {/* Disclaimer for specific product */}
      {/* {data?.product_id === 15 && data?.sub_product_id === 20 && (
      <div className="card-body border-top pt-3">
        <h6 className="section-title">{t("formNote.disclaimer")}</h6>
        <p className="small text-muted mb-0">{t("formNote.note")}</p>
      </div>
    )} */}

      {/* Pricing Footer */}
      <div className="pricing-section mt-auto">

        <div className="price-row">

          {/* LEFT : Base Price */}
          <div className="base-price-section">
            <h5 className="graphic-text">
              {data?.product_id === 15 && data?.sub_product_id === 20
                ? `${t("graphical_area_label")} : ${currentLanguage === "ar"
                  ? data?.area_of_coverage?.display_value_ar || "NA"
                  : data?.area_of_coverage?.display_value_en || "NA"
                }`
                : `${t("vehicle-value")} : ${data?.extracted_data?.vehicle_valuation || "N/A"
                }`}
            </h5>
            <div className="base-price-label">{t("basePrice")}</div>

            <div className="base-price-inline">
              <span className="currency-icon" style={{ marginTop: "4px" }}>
                {data?.premium_currency === "OMR" ? (
                  <OmrSymbol width={24} height={24} />
                ) : (
                  data?.premium_currency
                )}
              </span>
              <div>
                <span className="base-price-value">  {parseFloat(data?.base_price || 0).toFixed(3)}</span>
                <span className="tax-inline">+VAT Inc</span>
              </div>
            </div>
          </div>

          {/* RIGHT : Total + Button */}
          <div className="total-price-section">
            <div className="total-price-label">{t("totalPayment")}</div>

            <div className="total-price-value">
              <span className="currency-icon">
                {data?.premium_currency === "OMR" ? (
                  <OmrSymbol width={24} height={24} />
                ) : (
                  data?.premium_currency
                )}
              </span>
              {parseFloat(data?.premium_value || 0).toFixed(3)}
            </div>

            <button
              className="btn-buy-now"
              onClick={() => buyNowHandler(data)}
            >
              {t("buyNow")}
            </button>
          </div>

        </div>

        {/* <div className="vat-note">
          ({t("vat_include")})
        </div> */}
      </div>
    </div>
  );
};
